import * as userApi from '../../api/user-api';
import { USER_ROLE_ERROR } from '../../components/common/constants';
import { IErrorResult, IResult } from '../../models/result-models';
import { IUserModel } from '../../models/user-model';
import { getErrorMessage } from '../../utils/error-handling';
import { apiCallError, beginApiCall } from '../api/api-status-action';

export const LOAD_USER_SUCCESS = 'LOAD_USER_SUCCESS';
export const LOAD_USER_ERROR = 'LOAD_USER_ERROR';

export const CREATE_USER_SUCCESS = 'CREATE_USER_SUCCESS';
export const CREATE_USER_ERROR = 'CREATE_USER_ERROR';

export const UPDATE_USER_SUCCESS = 'UPDATE_USER_SUCCESS';
export const UPDATE_USER_ERROR = 'UPDATE_USER_ERROR';

export const DELETE_USER_SUCCESS = 'DELETE_USER_SUCCESS';
export const DELETE_USER_ERROR = 'DELETE_USER_ERROR';

export const ACTION_USER_FATAL = 'ACTION_USER_FATAL';

// Actions
const loadUserSuccess = (payload: IResult<IUserModel>) => ({
    type: LOAD_USER_SUCCESS,
    payload,
});

const loadUserError = (payload: string) => ({
    type: LOAD_USER_ERROR,
    payload,
});

const createUserSuccess = (payload: IResult<IUserModel>) => ({
    type: CREATE_USER_SUCCESS,
    payload,
});

const createUserError = (payload: IErrorResult) => ({
    type: CREATE_USER_ERROR,
    payload,
});

const updateUserSuccess = (payload: IResult<IUserModel>) => ({
    type: UPDATE_USER_SUCCESS,
    payload,
});

const updateUserError = (payload: IErrorResult) => ({
    type: UPDATE_USER_ERROR,
    payload,
});

const deleteUserSuccess = (payload: IResult<IUserModel>) => ({
    type: DELETE_USER_SUCCESS,
    payload,
});

const deleteUserError = (payload: IErrorResult) => ({
    type: DELETE_USER_ERROR,
    payload,
});

const actionUserFatal = (payload: IErrorResult) => ({
    type: ACTION_USER_FATAL,
    payload,
});

// Thunks
export const loadUser = (uid: string) => {
    return async (dispatch: any) => {
        try {
            dispatch(beginApiCall());
            const result = await userApi.getUser(uid);
            dispatch(loadUserSuccess(result));
        } catch (error) {
            dispatch(apiCallError(error));
            throw error;
        }
    };
};

export const deleteUser = (user: IUserModel) => {
    return async (dispatch: any) => {
        try {
            dispatch(beginApiCall());
            const result = await userApi.deleteUser(user.guid);

            if (result.ok) {
                dispatch(deleteUserSuccess({ ok: true, data: user }));
            } else {
                dispatch(deleteUserError({ errorMessage: result.message }));
            }

            return result.ok;
        } catch (error) {
            dispatch(actionUserFatal({ errorMessage: getErrorMessage(error) }));
            dispatch(apiCallError(error));
            return false;
        }
    };
};

export const saveUser = (user: IUserModel) => {
    return async (dispatch: any) => {
        try {
            dispatch(beginApiCall());
            const savedUserResult = await userApi.saveUser(user);
            if (savedUserResult.ok) {
                if (user.guid) {
                    dispatch(updateUserSuccess(savedUserResult));
                } else {
                    dispatch(createUserSuccess(savedUserResult));
                }
            } else {
                if (user.guid) {
                    dispatch(
                        updateUserError({ modelErrors: savedUserResult.errors })
                    );
                } else {
                    dispatch(
                        createUserError({ modelErrors: savedUserResult.errors })
                    );
                }

                dispatch(
                    apiCallError({ name: '', message: 'error saving user' })
                );
            }
            return savedUserResult.ok;
        } catch (error) {
            if (user.country === 'CA') {
                dispatch(actionUserFatal({ errorMessage: USER_ROLE_ERROR }));
            } else {
                dispatch(
                    actionUserFatal({ errorMessage: getErrorMessage(error) })
                );
            }
            dispatch(apiCallError(error));
            return false;
        }
    };
};
